export const AMAZONIAN = "AMAZONIAN";
export const ITSE = "ITSE";
export const STANDARD = "standard";
export const ITMPV1 = "itmpv1";
export const HAM_CONSUMER = "ham";
export const AMZNHAM_CONSUMER = "amznham";
export const PROCUREMENT = "procurement";
export const ITSE_ROLE = "itse";

/**
 * URL for filing bug reports via t.corp ticket template
 */
export const BUG_REPORT_URL = "https://t.corp.amazon.com/create/templates/e67ad600-f905-4e5f-95d3-ac2602054e05";

export const SUPPORT_MESSAGES_LABELS = {
  PENDING: "Pending",
  UP_TO_DATE: "Up to date",
  CLOSED: "Closed",
  NONE: "N/A",
};

export const LINE_ITEMS_ERROR_UI_STRING_PATH = 'orderDetails.tabs.itemsRequested.banners.errors';
export const ACTIONS = "Actions";
export const ORDER_LABELS_FILTER = "orderLabels.label";
